import React from 'react';
import { getSmoothStepPath, getEdgeCenter, getMarkerEnd } from 'react-flow-renderer';
import PropTypes from 'prop-types';

import styles from './Diagram.module.scss';

const Edge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style,
  arrowHeadType,
  markerEndId,
  onDeleteEdge,
  isPowerLine,
}) => {
  const edgePath = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 0,
  });
  const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);
  const [edgeCenterX, edgeCenterY] = getEdgeCenter({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });
  const foreignObjectSize = 25;

  const onEdgeClick = (evt, edgeId) => {
    evt.stopPropagation();
    onDeleteEdge(edgeId);
  };

  return (
    <g className={styles.edgePathGroup}>
      <path
        id={id}
        style={style}
        className={`react-flow__edge-path ${styles.edgePath} ${
          isPowerLine && styles.edgePathPrimary
        }`}
        d={edgePath}
        markerEnd={markerEnd}
      />
      <foreignObject
        width={foreignObjectSize}
        height={foreignObjectSize}
        x={edgeCenterX - foreignObjectSize / 2}
        y={edgeCenterY - foreignObjectSize / 2}
        className={styles.foreignObject}
        requiredExtensions="http://www.w3.org/1999/xhtml"
      >
        <button
          type="button"
          className={styles.edgeButton}
          onClick={(event) => onEdgeClick(event, id)}
        >
          ×
        </button>
      </foreignObject>
    </g>
  );
};

Edge.propTypes = {
  id: PropTypes.string.isRequired,
  sourceX: PropTypes.number.isRequired,
  sourceY: PropTypes.number.isRequired,
  targetX: PropTypes.number,
  targetY: PropTypes.number,
  sourcePosition: PropTypes.string.isRequired,
  targetPosition: PropTypes.string.isRequired,
  style: PropTypes.objectOf(PropTypes.any),
  arrowHeadType: PropTypes.string,
  markerEndId: PropTypes.string,
  onDeleteEdge: PropTypes.func.isRequired,
  isPowerLine: PropTypes.bool.isRequired,
};

Edge.defaultProps = {
  style: {},
  markerEndId: undefined,
  targetX: undefined,
  targetY: undefined,
  arrowHeadType: undefined,
};

export default Edge;
